/*
 * @Author: yuxiaojing
 * @Date: 2018-02-22 13:08:28
 * @Last Modified by: sunya
 * @Last Modified time: 2018-09-12 10:49:18
 * 用户操作
 */

// import { Toast } from 'mint-ui'
import axios from '@/utils/axios'

const oldTokenKey = 'vue-Token'
const TokenKey = 'accentToken'
const UserKey = 'vue-user'

/* token 操作 */
export function getLoaclToken () {
  return window.localStorage.getItem(oldTokenKey)
}
export function getToken () {
  return window.sessionStorage.getItem(TokenKey)
}

export function setToken (value) {
  return window.sessionStorage.setItem(TokenKey, value)
}

export function removeToken () {
  return window.localStorage.removeItem(TokenKey)
}

/* 用户信息操作 */
export function getUser () {
  return window.localStorage.getItem(UserKey)
}

export function setUser (value) {
  return window.localStorage.setItem(UserKey, value)
}

export function removeUser () {
  return window.localStorage.removeItem(UserKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js